import { NS_SVG } from "../constants";
import { SVG_ShiftX } from "./SVG_ShiftX";
import { SVG_ShiftY } from "./SVG_ShiftY";

export function SVG_DrawRect(x, y, width, height, borderColor, fillColor, svgElement) {
  x = SVG_ShiftX(x, svgElement);
  y = SVG_ShiftY(y, svgElement);

  var rectObj = document.createElementNS(NS_SVG, "rect");
  rectObj.setAttribute("x", x);
  rectObj.setAttribute("y", y);
  rectObj.setAttribute("width", width);
  rectObj.setAttribute("height", height);

  if (fillColor != null) rectObj.setAttribute("fill", fillColor);
  else rectObj.setAttribute("fill-opacity", 0);

  rectObj.setAttribute("stroke", borderColor);
  rectObj.setAttribute("stroke-width", 2);

  svgElement.appendChild(rectObj);
}
